// DISPLAY-ONLY cadence for the summer acquisition funnel.
//
// The summer edition contains four effective teaching weeks per month. This
// helper deliberately does not read the subscription/proration hours grid: that
// grid still carries the annual ~4.33-week cadence in some environments and its
// financial correction is owned by P-2339. P-2393 must not change billing,
// credits, or server-side proration.
export const SUMMER_DISPLAY_WEEKS_PER_MONTH = 4

export const getSummerDisplayHoursPerMonth = (weeklyHours) => {
    const parsedWeeklyHours = Number(weeklyHours)
    if (!Number.isFinite(parsedWeeklyHours) || parsedWeeklyHours <= 0) return null

    return parsedWeeklyHours * SUMMER_DISPLAY_WEEKS_PER_MONTH
}

export const getSummerDisplayHourlyPrice = (monthlyPrice, weeklyHours) => {
    const parsedMonthlyPrice = Number(monthlyPrice)
    const displayHoursPerMonth = getSummerDisplayHoursPerMonth(weeklyHours)

    if (!Number.isFinite(parsedMonthlyPrice) || parsedMonthlyPrice < 0) return null
    if (!displayHoursPerMonth) return null

    return (
        Math.round(
            (parsedMonthlyPrice / displayHoursPerMonth + Number.EPSILON) * 100
        ) / 100
    )
}
